<template>
  <div id="app">
    <Header class="header" />
    <div class="cont-box" @scroll="scrollfn" ref="cont">
      <router-view />
      <Footer />
    </div>

  </div>
</template>

<script>
import Header from "./components/Header";
import Footer from "./components/Footer";

export default {
  name: "app",
  components: {
    Header,
    Footer
  },
  data(){
    return {
      ismore:false
    }
  },
  methods:{
    scrollfn(){
      // console.log(this.$route.name=='News');
      if(this.$route.name=='News'){
        let el=this.$refs.cont
        var oheight=el.scrollHeight;
        var otop =el.scrollTop

        
        if(otop+800>=oheight && !this.ismore){
          this.ismore=true;
          
        }
      }
      // console.log(this.ismore);
    }
  }
};
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  outline: 0;
  -webkit-tap-highlight-color: transparent;

}

html {
  -webkit-text-size-adjust: none;
  -webkit-font-smoothing: antialiased;
  
}

body,
html {
  height: 100%;
  font-size: 0.3rem;
  color: $baseColor;
  font-family: '微软雅黑';
  -webkit-overflow-scrolling : touch;
  
}

a {
  text-decoration: none;
  color: $baseColor;
}
li {
  list-style: none;
}
.banner-box {
  position: relative;
  img {
    width: 100%;
    display: block;
  }
  .nav-list-box{
    position: absolute;
    bottom:0;
    left:0;
    width:100%;
    height:.8rem;
    @extend .flex;
    @extend .bg;
    li{
      flex:1;
      line-height: .8rem;
      color:#fff;
      font-size: .26rem;
      text-align: center;
      &.active{
        color:$activeColor;
      }
    }
  }
}
#app {
  position: absolute;
  left: 0;
  top: 0;
  overflow: hidden;
  width: 100%;
  height: 100%;
  @extend .flex-column;
  .header {
    height: 0.77rem;
    min-height: 0.77rem;
    max-height: 0.77rem;
    flex: 1;
  }
  .cont-box {
    flex: 1;
    overflow: scroll;
    -webkit-overflow-scrolling : touch;
  }
}
</style>
